var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iconCell"},[_c('div',{class:[_vm.icon,'iconfont']}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.icon))])])
}
var staticRenderFns = []

export { render, staticRenderFns }